"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyNameEditor = void 0;
var react_1 = __importDefault(require("react"));
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var Button_1 = require("office-ui-fabric-react/lib/Button");
/**
 * StrategyNameEditor - Inline TextField shown while the user is creating or
 * renaming a strategy. Submits on Enter, cancels on Escape.
 */
exports.StrategyNameEditor = function (_a) {
    var mode = _a.mode, value = _a.value, onChange = _a.onChange, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var isAdd = mode === "add";
    return (react_1.default.createElement("div", { className: "ws-strategy-inline-edit" },
        react_1.default.createElement(TextField_1.TextField, { label: isAdd ? "New strategy name" : "Rename strategy", value: value, onChange: function (_, val) { return onChange(val || ""); }, placeholder: "Enter strategy name", autoFocus: true, onKeyDown: function (e) {
                if (e.key === "Enter")
                    onConfirm();
                if (e.key === "Escape")
                    onCancel();
            }, styles: { root: { flex: 1 } } }),
        react_1.default.createElement(Button_1.DefaultButton, { text: "Confirm", iconProps: { iconName: "Accept" }, title: isAdd ? "Create strategy" : "Save strategy name", ariaLabel: isAdd ? "Create strategy" : "Save strategy name", className: "ws-admin-button-hover-success", onClick: onConfirm, disabled: !value.trim() }),
        react_1.default.createElement(Button_1.DefaultButton, { text: "Discard", iconProps: { iconName: "Undo" }, title: "Discard strategy name changes", ariaLabel: "Discard strategy name changes", className: "ws-admin-button-hover-accent", onClick: onCancel })));
};
